type Props = {
  maxCount: number;
  currentCount: number;
  color?: string;
};

const CircularProgress = ({ maxCount, currentCount, color = '#111' }: Props) => {
  const percentage = Math.min(Math.round((currentCount / maxCount) * 100), 100);

  const strokeWidth = 2.5;
  const size = 18;
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference - (percentage / 100) * circumference;

  return (
    <div className={`relative flex items-center justify-center w-[18px] h-[18px]`}>
      <svg width={size} height={size} className="rotate-[-90deg] absolute">
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          className="stroke-neutral-300"
          strokeWidth={strokeWidth}
          fill="none"
        />
      </svg>
      <svg width={size} height={size} className="rotate-[-90deg] absolute">
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          style={{ stroke: color }}
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          strokeLinecap="round"
          fill="none"
        />
      </svg>
    </div>
  );
};

export default CircularProgress;
